import Main from '@/main.vue';
export const hiddenMenu = [
  {
    path: '/hiddenMenu',
    name: 'hiddenMenu',
    component: Main,
    meta: {
      title: '',
      icon: 'md-home',
      hideInMenu: true
    },
    children: [
      {
        path: '/successTransfer',
        component: () => import('@views/bpm/launchApproval/successTransfer/index.vue'),
        name: '提交成功中转页',
        meta: { title: '提交成功中转页', hideInMenu: true }
      },
      {
        path: '/launchApprovalDetail',
        component: () => import('@views/bpm/launchApproval/launchApprovalDetail/index.vue'),
        name: '发起审批详情',
        meta: { title: '发起审批详情', hideInMenu: true }
      },
      {
        path: '/approvalDetail',
        component: () => import('@views/bpm/approvalTask/approvalDetail/index.vue'),
        name: '审批详情',
        meta: { title: '审批详情', hideInMenu: true }
      }
    ]
  },
  {
    path: '/approvalTaskMaximize',
    name: 'approvalTaskMaximize',
    component: () => import('../../views/bpm/approvalTask/approvalTaskList/index.vue'),
    meta: {
      title: '审批列表',
      icon: 'md-home',
      hideInMenu: true
    }
  },
  {
    path: '/approvalDetailMaximize',
    name: 'approvalDetailMaximize',
    component: () => import('../../views/bpm/approvalTask/approvalDetail/index.vue'),
    meta: {
      title: '审批详情',
      icon: 'md-home',
      hideInMenu: true
    }
  },
  {
    path: '/launchApprovalDetailMaximize',
    name: 'launchApprovalDetailMaximize',
    component: () => import('@views/bpm/launchApproval/launchApprovalDetail/index.vue'),
    meta: { title: '发起审批详情', hideInMenu: true }
  }
];
